module.exports = __WEBPACK_EXTERNAL_MODULE_55__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","isSameDay"],"commonjs":"date-fns/is_same_day/index","commonjs2":"date-fns/is_same_day/index"}
// module id = 55
// module chunks = 0